module.exports = __webpack_public_path__ + "static/media/zitsaMap.a5e70bc4.png";